import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'zag-page-layout',
  imports: [],
  templateUrl: './page-layout.html',
  styleUrl: './page-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.zag-page-layout]': 'true',
  },
})
export class PageLayout {
  /**
   * Additional padding size
   * @default 'md'
   */
  readonly padding = input<'sm' | 'md' | 'lg' | null>('md');
}
